// src/modules/finan/hooks/useBatchGenerateInvoiceByRow.ts

import { useToast } from "../../../shared/hooks";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";
import { ToastContent } from "../../../shared/components";
import { generateReferenceFromPeriod, getDueDateFromDay } from "../utils/due_date_utils";
import { v4 as uuid } from "uuid";

export interface IGenerateInvoice {
	clientId: string;
	dueDate: string;
	reference: string;
	id: string;
	value: string;
	installmentsNumber: number;
	gateway: "EMPTY";
	status: "pending";
}

interface RowToInvoice {
	clientId: string;
	name: string;
	sum_amount: string;
	count_amount: string;
	day_due_date?: string; // importante para calcular o vencimento
}

interface UseBatchGenerateInvoiceByRowParams {
	setIsLoading: (v: boolean) => void;
	onSuccess?: () => void;
	dataIni: string;
	dataFim: string;
}

export const useBatchGenerateInvoiceByRow = ({
	setIsLoading,
	onSuccess,
	dataIni,
	dataFim,
}: UseBatchGenerateInvoiceByRowParams) => {
	const toastHandler = useToast();

	const handleBatchGenerateInvoice = async (selectedRows: RowToInvoice[]) => {
		setIsLoading(true);

		try {
			const reference = generateReferenceFromPeriod(dataIni, dataFim);

			const requests = selectedRows.map((row) => {
				const dueDate = getDueDateFromDay(Number(row.day_due_date || 0));

				const payload: IGenerateInvoice = {
					id: uuid(),
					clientId: row.clientId,
					dueDate : dueDate +' 12:00:00',
					reference,
					value: row.sum_amount,
					installmentsNumber: Number(row.count_amount),
					gateway: "EMPTY",
					status: "pending",
				};

				// ⏩ Faz o POST com os parâmetros na URL
				return FinancialService.generateInvoice(payload, dataIni, dataFim);
			});

			await Promise.all(requests);

			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Faturas geradas com sucesso." />,
			});
			onSuccess?.();
		} catch (error: any) {
			console.error("Erro ao gerar faturas:", error);
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="Erro inesperado ao gerar faturas." />,
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { handleBatchGenerateInvoice };
};;
